<nav class="breadcrumb px-3 pt-4" aria-label="breadcrumbs">
  <ul>
    <li
      *ngFor="let breadcrumb of breadcrumbs; let last = last"
      [class.is-active]="last"
    >
      <a *ngIf="!last" [routerLink]="breadcrumb.url">{{
        breadcrumb.label | translate
      }}</a>
      <span *ngIf="last">{{ breadcrumb.label | translate }}</span>
    </li>
  </ul>
</nav>
